export const PARTICIPANT_SIGNER_TYPES = ['participant', 'non-signing participant'];
